export const TYPE = {
  GET_FREE_TRIAL_VIP: 'GET_FREE_TRIAL_VIP',
  GET_FILLING_USER_DATA_FREE_VIP: 'GET_FILLING_USER_DATA_FREE_VIP',
};

export default {TYPE};
